
import React, { useState } from 'react';
import { MapPin, Calendar } from 'lucide-react';

const galleryItems = [
  {
    id: 1,
    title: "Executive Team Meeting",
    category: "Corporate Events",
    date: "March 15, 2025",
    location: "Headquarters, Jakarta",
    description: "Our leadership team discussing strategy with key clients to drive future growth and innovation.",
    imageUrl: "https://ik.imagekit.io/satfy9rkc/Indonesian%20Photoes/11.jpeg?updatedAt=1745579758916",
    featured: true,
  },
  {
    id: 2,
    title: "Global Conference 2025",
    category: "Corporate Events",
    date: "April 02, 2025",
    location: "Singapore Convention Center",
    description: "Our leadership team representing the organization globally at the annual tech summit.",
    imageUrl: "https://ik.imagekit.io/satfy9rkc/HomePage/shared%20image%20(1).jpeg?updatedAt=1746159234958",
  },
  {
    id: 3,
    title: "Annual Celebration",
    category: "Corporate Events",
    date: "December 20, 2024",
    location: "Grand Ballroom",
    description: "Celebrating our achievements with team members and clients in a night of recognition.",
    imageUrl: "https://ik.imagekit.io/satfy9rkc/Indonesian%20Photoes/9.jpeg?updatedAt=1745579758912"
  },
  {
    id: 4,
    title: "Team Building Retreat",
    category: "Corporate Events",
    date: "January 10, 2025",
    location: "Mountain Resort",
    description: "Senior managers and client representatives enjoying outdoor activities to strengthen bonds.",
    imageUrl: "https://ik.imagekit.io/satfy9rkc/Indonesian%20Photoes/1.jpeg?updatedAt=1745579759169"
  },
  {
    id: 5,
    title: "Collaboration Meeting",
    category: "Corporate Events",
    date: "February 05, 2025",
    location: "Innovation Hub",
    description: "Team members participating in collaborative discussions to solve complex challenges.",
    imageUrl: "https://ik.imagekit.io/satfy9rkc/Indonesian%20Photoes/2.jpeg?updatedAt=1745579759170"
  },
  {
    id: 6,
    title: "Team Outing",
    category: "Team Outing",
    date: "May 12, 2025",
    location: "Sunset Beach",
    description: "Relaxing day at the Restaurant with colleagues, enjoying team activities and bonding over fun games.",
    imageUrl: "https://ik.imagekit.io/satfy9rkc/Lunch%20outing/Lunch%20outing%204.jpg?updatedAt=1755146479471"
  },
  {
    id: 7,
    title: "Mountain Trekking",
    category: "Team Outing",
    date: "June 08, 2025",
    location: "Mount Gede",
    description: "Team bonding through challenging mountain trails and enjoying breathtaking views.",
    imageUrl: "https://ik.imagekit.io/satfy9rkc/Lunch%20outing/Lunch%20outing%205.jpg?updatedAt=1755146479467"
  },
  {
    id: 8,
    title: "City Park Picnic",
    category: "Team Outing",
    date: "July 14, 2025",
    location: "Central Park",
    description: "Relaxing afternoon with colleagues and their families enjoying food and games.",
    imageUrl: "https://ik.imagekit.io/satfy9rkc/Lunch%20outing/Lunch%20outing%201.jpg?updatedAt=1755146479410"
  },
  {
    id: 9,
    title: "Go-Kart Racing",
    category: "Team Outing",
    date: "August 22, 2025",
    location: "Speedway Circuit",
    description: "Competitive racing event fostering team spirit and adrenaline-filled fun.",
    imageUrl: "https://ik.imagekit.io/satfy9rkc/Lunch%20outing/Lunch%20outing%203.jpg?updatedAt=1755146479394"
  },
  {
    id: 10,
    title: "Strategy Workshop",
    category: "Seminars",
    date: "September 10, 2025",
    location: "Conference Room A",
    description: "Deep dive into next year's strategic goals with industry experts.",
    imageUrl: "https://ik.imagekit.io/satfy9rkc/Indonesian%20Photoes/11.jpeg?updatedAt=1745579758916"
  },
  {
    id: 11,
    title: "Client Visit",
    category: "Visits",
    date: "October 05, 2025",
    location: "Main Office",
    description: "Welcoming our international partners for a tour of our facilities.",
    imageUrl: "https://ik.imagekit.io/satfy9rkc/HomePage/shared%20image%20(1).jpeg?updatedAt=1746159234958"
  },
  {
    id: 12,
    title: "Awards Night",
    category: "Corporate Events",
    date: "November 15, 2025",
    location: "City Hall",
    description: "Recognizing the hard work and dedication of our top performers.",
    imageUrl: "https://ik.imagekit.io/satfy9rkc/Indonesian%20Photoes/9.jpeg?updatedAt=1745579758912"
  },
];

const ALL_CATEGORIES = ['All', ...Array.from(new Set(galleryItems.map(i => i.category)))];

const Photoes = () => {
  const [activeCategory, setActiveCategory] = useState('All');
  const [lightboxItem, setLightboxItem] = useState(null);

  const filtered = activeCategory === 'All'
    ? galleryItems
    : galleryItems.filter(i => i.category === activeCategory);

  return (
    <div className="w-full bg-white py-20 lg:py-20 overflow-hidden">
      <style>{`
        .gallery-item { transition: transform 0.4s ease, box-shadow 0.4s ease; }
        .gallery-item:hover { transform: translateY(-6px); box-shadow: 0 24px 48px rgba(0,0,0,0.12); }
        .gallery-overlay { 
          background: linear-gradient(to top, rgba(26,38,52,0.92) 0%, rgba(26,38,52,0.3) 50%, transparent 100%);
          opacity: 0;
          transition: opacity 0.4s ease;
        }
        .gallery-item:hover .gallery-overlay { opacity: 1; }
        .gallery-item:hover .gallery-img { transform: scale(1.06); }
        .gallery-img { transition: transform 0.6s ease; }
        .filter-btn { transition: all 0.25s ease; }
        .filter-btn.active { background-color: #FF4A3D; color: #fff; }
        .filter-btn:not(.active):hover { background-color: #f3f4f6; }
        .lightbox-backdrop { 
          position: fixed; inset: 0; z-index: 9999; 
          background: rgba(0,0,0,0.88); 
          display: flex; align-items: center; justify-content: center;
          padding: 24px;
          animation: fadeIn 0.25s ease;
        }
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        .lightbox-card { 
          background: white; border-radius: 20px; overflow: hidden; 
          max-width: 900px; width: 100%;
          animation: scaleIn 0.3s ease;
        }
        @keyframes scaleIn { from { transform: scale(0.95); opacity: 0; } to { transform: scale(1); opacity: 1; } }
      `}</style>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="mb-12 max-w-6xl">
          <h2 className="text-[#1A2634] text-3xl md:text-4xl lg:text-5xl font-bold mb-6 leading-tight">
            Capturing Excellence in Every Frame
          </h2>
          <p className="text-lg leading-relaxed">
            Every picture tells a story — our gallery captures the moments that define our culture, our collaborations, and our commitment to success.
          </p>
        </div>

        {/* Category Filter Pills */}
        <div className="flex flex-wrap gap-3 mb-12">
          {ALL_CATEGORIES.map(cat => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`filter-btn px-5 py-2 rounded-full text-sm font-semibold border ${
                activeCategory === cat ? 'active border-transparent' : 'border-gray-200'
              }`}
              style={{
                backgroundColor: activeCategory === cat ? '#FF4A3D' : '#FFFFFF',
                color: activeCategory === cat ? '#FFFFFF' : '#4B5563',
              }}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Masonry-style Grid */}
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 space-y-6">
          {filtered.map((item) => (
            <div
              key={item.id}
              className="gallery-item break-inside-avoid overflow-hidden cursor-pointer relative group bg-gray-100"
              onClick={() => setLightboxItem(item)}
            >
              <div className="overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="gallery-img w-full h-auto object-cover"
                  loading="lazy"
                />
              </div>

              {/* Hover Overlay */}
              <div className="gallery-overlay absolute inset-0 flex flex-col justify-end p-6">
                <span className="text-[#FF4A3D] text-xs font-bold uppercase tracking-wider mb-2">
                  {item.category}
                </span>
                <h3 className="text-white text-xl font-bold mb-2 leading-snug">
                  {item.title}
                </h3>
                <div className="flex items-center gap-4 text-white/70 text-xs">
                  <span className="flex items-center gap-1">
                    <MapPin className="w-3 h-3" /> {item.location}
                  </span>
                  <span className="flex items-center gap-1">
                    <Calendar className="w-3 h-3" /> {item.date}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>

      {/* Lightbox */}
      {lightboxItem && (
        <div className="lightbox-backdrop" onClick={() => setLightboxItem(null)}>
          <div className="lightbox-card" onClick={e => e.stopPropagation()}>
            <div className="relative">
              <img
                src={lightboxItem.imageUrl}
                alt={lightboxItem.title}
                className="w-full max-h-[500px] object-cover"
              />
              <button
                onClick={() => setLightboxItem(null)}
                className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/90 flex items-center justify-center text-gray-700 hover:bg-white shadow-lg text-xl font-bold transition-all"
              >
                ×
              </button>
              <div className="absolute top-4 left-4">
                <span className="px-3 py-1 rounded-full bg-[#FF4A3D] text-white text-xs font-bold uppercase tracking-wider">
                  {lightboxItem.category}
                </span>
              </div>
            </div>
            <div className="p-8">
              <h3 className="text-[#1A2634] text-2xl font-bold mb-3">{lightboxItem.title}</h3>
              <p className="text-gray-600 text-base leading-relaxed mb-6">{lightboxItem.description}</p>
              <div className="flex flex-wrap items-center gap-6 text-sm text-gray-500">
                <span className="flex items-center gap-2">
                  <MapPin className="w-4 h-4 text-[#FF4A3D]" /> {lightboxItem.location}
                </span>
                <span className="flex items-center gap-2">
                  <Calendar className="w-4 h-4 text-[#FF4A3D]" /> {lightboxItem.date}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Photoes;